module.exports = __webpack_public_path__ + "img/fire.51b08127.png";